import { useParceiro } from "@/parceiros/contexto"
import { INSTITUICOES } from "../schema"

// A tela traduz antes de pedir qualquer coisa: na guia do RH os nossos contratos saem sob o código
// de quem opera a operação, e quem procura "Faz Cred" no arquivo conclui que não tem nada dele ali.
export const BlocoInstituicoes = () => {
    const parceiro = useParceiro()
    return (
        <div className="mt-4 rounded-lg bg-brand-wash px-5 py-4">
            <p className="font-semibold">
                Procurando {parceiro.comArtigo} na sua guia? Ela não aparece com esse nome.
            </p>
            <p className="mt-1 text-sm text-soft">
                Os contratos dos seus colaboradores conosco são operados por estas instituições, e é
                o código delas que sai no campo <em>Instituição Financeira</em> do arquivo:
            </p>
            {/* Cada marca fica sobre branco nos dois temas: são logos de terceiros, desenhados para
            fundo claro, e sobre o azul profundo do tema escuro simplesmente sumiriam. */}
            <ul className="mt-3 flex flex-wrap gap-2">
                {INSTITUICOES.map((instituicao) => (
                    <li
                        key={instituicao.codigo}
                        className="flex items-center gap-3 rounded-lg border border-line-strong bg-white px-3 py-2"
                    >
                        <img
                            src={instituicao.logo}
                            alt={instituicao.nome}
                            className="h-5 w-auto"
                            loading="lazy"
                        />
                        <b className="font-mono text-sm text-brand">{instituicao.codigo}</b>
                    </li>
                ))}
            </ul>
        </div>
    )
}
